import { NavLink } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const ICONS = {
  home: (
    <path d="M3 11.5 12 4l9 7.5M5 10v9a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9" />
  ),
  persona: <circle cx="12" cy="8" r="4" />,
  resume: <path d="M6 3h9l4 4v14H6zM14 3v5h5M9 13h6M9 17h6" />,
  match: <path d="M17 20a4 4 0 1 0-8 0M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM3 20a4 4 0 0 1 4-4M21 20a4 4 0 0 0-4-4" />,
  interview: <path d="M21 11.5a8.5 8.5 0 1 1-4-7.2L21 3l-1 4.8a8.4 8.4 0 0 1 1 3.7Z" />,
} as const;

function Icon({ name, active }: { name: keyof typeof ICONS; active: boolean }) {
  return (
    <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke={active ? "#0EA5E9" : "#94A3B8"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      {ICONS[name]}
    </svg>
  );
}

export function BottomNav() {
  const { user } = useAuth();
  const isCompany = user?.role === "company";

  const talentItems = [
    { to: "/app", label: "Home", icon: "home" as const, end: true },
    { to: "/app/persona", label: "Persona", icon: "persona" as const },
    { to: "/app/resume", label: "Resume", icon: "resume" as const },
    { to: "/app/matches", label: "Matches", icon: "match" as const },
    { to: "/app/interview", label: "Interview", icon: "interview" as const },
  ];

  const companyItems = [
    { to: "/company", label: "Dashboard", icon: "home" as const, end: true },
    { to: "/company/culture", label: "Culture", icon: "persona" as const },
    { to: "/company/talent", label: "Talent", icon: "match" as const },
    { to: "/company/interview", label: "Interview", icon: "interview" as const },
  ];

  const items = isCompany ? companyItems : talentItems;

  return (
    <nav className="safe-bottom fixed inset-x-0 bottom-0 z-40 flex justify-around border-t border-slate-200 bg-white/95 backdrop-blur lg:hidden">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className="flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px]"
        >
          {({ isActive }) => (
            <>
              <Icon name={item.icon} active={isActive} />
              <span className={isActive ? "font-semibold text-teal-dark" : "text-slate-400"}>{item.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
